{
  "generating": "Génération en cours",
  "reviewTrades": "Examiner les opérations",
  "updateTrades": "Mettre à jour les exécutions d'opération",
  "completed": "Terminé",
  "generatingDescription": "Les opérations sont en cours de génération…",
  "rebalanceOn": "Rééquilibrer le",
  "rebalanceCanceled": "Le rééquilibrage est annulé. Revenez en arrière pour en lancer un nouveau.",
  "buyTradeFile": "Télécharger le fichier des opérations d'achat",
  "sellTradeFile": "Télécharger le fichier des opérations de vente",
  "mutualFundTradeFile": "Télécharger le fichier des opérations de fonds communs",
  "ptfBulkTradeFile": "Télécharger le fichier des opérations groupées PTF",
  "tradeViaFix": "Opération via FIX",
  "bulkBUYTrades": "Opérations d'achat groupées",
  "bulkSELLTrades": "Opérations de vente groupées",
  "cancelRebalanceTrades": "Annuler les opérations de rééquilibrage",
  "rebalanceCompleted": "Rééquilibrage terminé",
  "allPricesNotUpdated": "Les prix n'ont pas encore tous été mis à jour",
  "pasteFromExcel": "Copier/coller à partir d'Excel",
  "orderOfContent": "Vérifiez que les colonnes sont par ordre de symbole, prix, quantité",
  "cancelConfirmationDialog": "Avant d'annuler, vérifiez que vous n'avez pas envoyé les fichiers d'opérations groupées. Si vous avez déjà envoyé les fichiers d'opérations groupées, le système génèrera une ERREUR, car toutes ces opérations ont été envoyées au dépositaire.",
  "cancelTriggeredMessage": "L'annulation des opérations de rééquilibrage a été déclenchée!",
  "discrepancyConfirmationDialog": {
    "title": "Divergences dans les opérations groupées",
    "text": "Il existe des divergences dans les quantités ou les prix alloués. Voulez-vous vraiment continuer?"
  },
  "orderOfPortfolioContent": "Vérifiez que les colonnes sont par ordre de symbole et de pourcentage",
  "generate": "Générer"
}
